import { render, staticRenderFns } from "./CamstudyAlert.vue?vue&type=template&id=032fbc61&scoped=true&"
import script from "./CamstudyAlert.vue?vue&type=script&lang=js&"
export * from "./CamstudyAlert.vue?vue&type=script&lang=js&"
import style0 from "./CamstudyAlert.vue?vue&type=style&index=0&id=032fbc61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032fbc61",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('032fbc61')) {
      api.createRecord('032fbc61', component.options)
    } else {
      api.reload('032fbc61', component.options)
    }
    module.hot.accept("./CamstudyAlert.vue?vue&type=template&id=032fbc61&scoped=true&", function () {
      api.rerender('032fbc61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/camstudyAlert/CamstudyAlert.vue"
export default component.exports